import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import moment from 'moment';
import {
  Modal, ModalBody, ModalHeader, ModalFooter,
} from 'reactstrap';

import OrderTable from './orderTable';
import ProductTable from './productTable';
import LotTable from './lotTable';

import {
  getListInboundOrdersOnly, undoInboundOrderCheck, undoInboundOrderProductCheck,
  assignCheckUser, getBranchUsers, updateNote, updateProductInspection, updateOrderNote, cancelOrder,
  getListInboundOrderProducts, getListInboundOrderProductLots, getListInboundOrderProductPartial, undoInboundStorage,
  undoInboundProductStorage, validateUndoInboundStorage, validateUndoInboundProductStorage,
} from '../../../app/store/actions/inboundOrders';

import { getUserPrinterOptions } from '../../../app/store/actions/printers';
import { printPreConferenceLabel } from '../../../app/store/actions/labels';
import { syncStorage } from '../../../app/store/actions/inboundStorage';
import { getPageLayout, updatePageLayout } from '../../../app/store/actions/pageLayout';

import addNotification from '../../../components/notification';
import Form from '../../../components/form/form';
import OneClickButton from '../../../components/form/button';

import WikiHelp from '../../../components/tooltip/wikiHelp';
import ROUTES from '../../../config/routes';

class InboundOrdersPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inboundOrderSelect: {},
      productSelect: {},
      productLotsPanel: [],
      inboundOrdersProductsPanel: [],
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      showModalPageLayout: false,
      pageLayout: {
        showSupplier: true,
        showOrderType: true,
        showSerie: true,
        showStatus: true,
        showPrintLabel: true,
        showDeliveryDate: true,
        showPrintedDate: true,
        showIntegrationDate: true,
        showVolumes: true,
        showInspection: true,
        showVehiclePlate: true,
        showPlateCheck: true,
        showChecked: true,
        showStored: true,
        showCanceled: true,
        showDivergence: true,
        showUserCheck: true,
        showPlateCheckUser: true,
        showPlateCheckDate: true,
        showStartCheckUser: true,
        showStartCheckDate: true,
        showFinishCheckUser: true,
        showFinishCheckDate: true,
        showStartStorageUser: true,
        showStartStorageDate: true,
        showFinishStorageUser: true,
        showFinishStorageDate: true,
        showCancelUser: true,
        showCancelDate: true,
        showDivergenceUser: true,
        showDivergenceDate: true,
        showProductName: true,
        showProductComplementCode: true,
        showUnitMeasure: true,
        showBaptismLabel: true,
        showQuantity: true,
        showQuantityCheck: true,
        showInspected: true,
        showInspectedAt: true,
        showInspectionUser: true,
        showInspectionNotes: true,
        showPending: true,
        showQuantityStorage: true,
        showQuantityDamage: true,
        showQuantityDivergence: true,
        showProductStatus: true,
        showPurchaseOrder: true,
        showControlExpirationDate: true,
        showStockControlType: true,
        showCheckUser: true,
        showCheckProductAt: true,
        showStorageUser: true,
        showStorageProductAt: true,
        showLotProductCode: true,
        showLotProductName: true,
        showLotSerialGroupCode: true,
        showLotStatus: true,
        showLotQuantity: true,
        showLotQuantityStorage: true,
        showLotQuantityDamage: true,
        showLotExpDate: true,
        showLotStorageUser: true,
        showLotStorageProductAt: true,
      },
      showSupplier: true,
      showOrderType: true,
      showSerie: true,
      showStatus: true,
      showPrintLabel: true,
      showDeliveryDate: true,
      showPrintedDate: true,
      showIntegrationDate: true,
      showVolumes: true,
      showInspection: true,
      showVehiclePlate: true,
      showPlateCheck: true,
      showChecked: true,
      showStored: true,
      showCanceled: true,
      showDivergence: true,
      showUserCheck: true,
      showPlateCheckUser: true,
      showPlateCheckDate: true,
      showStartCheckUser: true,
      showStartCheckDate: true,
      showFinishCheckUser: true,
      showFinishCheckDate: true,
      showStartStorageUser: true,
      showStartStorageDate: true,
      showFinishStorageUser: true,
      showFinishStorageDate: true,
      showCancelUser: true,
      showCancelDate: true,
      showDivergenceUser: true,
      showDivergenceDate: true,
      showProductName: true,
      showProductComplementCode: true,
      showUnitMeasure: true,
      showBaptismLabel: true,
      showQuantity: true,
      showQuantityCheck: true,
      showInspected: true,
      showInspectedAt: true,
      showInspectionUser: true,
      showInspectionNotes: true,
      showPending: true,
      showQuantityStorage: true,
      showQuantityDamage: true,
      showQuantityDivergence: true,
      showProductStatus: true,
      showPurchaseOrder: true,
      showControlExpirationDate: true,
      showStockControlType: true,
      showCheckUser: true,
      showCheckProductAt: true,
      showStorageUser: true,
      showStorageProductAt: true,
      showLotProductCode: true,
      showLotProductName: true,
      showLotSerialGroupCode: true,
      showLotStatus: true,
      showLotQuantity: true,
      showLotQuantityStorage: true,
      showLotQuantityDamage: true,
      showLotExpDate: true,
      showLotStorageUser: true,
      showLotStorageProductAt: true,
    };
  }

  componentDidMount() {
    this.getPageLayout();
    this.getInboundOrders();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.userLogged && this.props.userLogged) {
      this.getPageLayout();
    }
  }

  keepStatusOfSelected = async () => {
    const { inboundOrderSelect, productSelect } = this.state;
    if (Object.keys(inboundOrderSelect).length && this.props.inboundOrdersPanel.find(
      (elem) => elem.id === inboundOrderSelect.id,
    )) {
      const newInboundOrderSelect = this.props.inboundOrdersPanel.find((elem) => elem.id === inboundOrderSelect.id);
      await this.setInboundOrderSelect(newInboundOrderSelect, false);

      if (Object.keys(productSelect).length && this.state.inboundOrdersProductsPanel.find(
        (elem) => elem.id === productSelect.id,
      )) {
        const newInboundOrdersProductsPanel = this.state.inboundOrdersProductsPanel.find(
          (elem) => elem.id === productSelect.id,
        );
        await this.setInboundOrderProductSelect(newInboundOrdersProductsPanel, false);
        this.setState({
          inboundOrderSelect: newInboundOrderSelect,
          productSelect: newInboundOrdersProductsPanel,
        });
      } else {
        this.setState({
          inboundOrderSelect: newInboundOrderSelect,
          productSelect: {},
          productLotsPanel: [],
        });
      }
    } else {
      this.setState({
        inboundOrderSelect: {},
        productSelect: {},
        productLotsPanel: [],
        inboundOrdersProductsPanel: [],
      });
    }
  };

  getInboundOrders = async () => {
    const { startDate, endDate } = this.state;

    await this.props.getListInboundOrdersOnly(startDate, endDate);
    await this.keepStatusOfSelected();
  };

  handleDateApplyEvent = async (event) => {
    const startDate = event[0];
    const endDate = event[1];

    await this.setState({
      startDate,
      endDate,
    });

    this.getInboundOrders();
  };

  setInboundOrderSelect = async (inboundOrderSelect, reset = true) => {
    if (!reset || !Object.keys(this.state.inboundOrderSelect).length
    || inboundOrderSelect.id !== this.state.inboundOrderSelect.id) {
      const result = await this.props.getListInboundOrderProducts(inboundOrderSelect.id);
      const resetProduct = reset ? {
        productSelect: {},
        productLotsPanel: [],
      } : {};

      this.setState({
        inboundOrderSelect,
        inboundOrdersProductsPanel: result || [],
        ...resetProduct,
      });
    }
  };

  setInboundOrderProductSelect = async (productSelect, reset = true) => {
    if (!reset || !Object.keys(this.state.productSelect).length || productSelect.id !== this.state.productSelect.id) {
      const result = await this.props.getListInboundOrderProductLots(productSelect.id);
      this.setState({
        productSelect,
        productLotsPanel: result || [],
      });
    }
  };

  cancelOrder = async (inboundOrderId, cancelNote) => {
    try {
      const result = await this.props.cancelOrder(inboundOrderId, cancelNote);

      if (result && result.error) {
        addNotification('danger', I18n.t('BEE440' /* Monitor de Recebimento */), result.error, 'top-right');
      } else {
        addNotification(
          'success',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          'Documento cancelado com sucesso!',
          'top-right',
        );
        await this.getInboundOrders();
        // const orderSelect = this.props.inboundOrdersPanel.find(order => order.id === inboundOrderId)
        // await this.setInboundOrderSelect(orderSelect)
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            'Erro ao cancelar documento',
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          'Erro ao cancelar documento',
          'top-right',
        );
      }
    }
  };

  getListInboundOrderProductPartial = async () => {
    const { productSelect } = this.state;

    try {
      const inboundOrderProductPartial = await this.props.getListInboundOrderProductPartial(productSelect.id);
      if (inboundOrderProductPartial) {
        return inboundOrderProductPartial;
      }
      return [];
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        addNotification('danger', I18n.t('BEE440' /* Monitor de Recebimento */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  undoInboundStorage = async (inboundOrderId) => {
    try {
      const result = await this.props.undoInboundStorage(inboundOrderId);

      if (result.error) {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          result.error,
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE4835' /* Armazenamento desfeito com sucesso */),
          'top-right',
        );
        await this.getInboundOrders();
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            I18n.t('BEE4837' /* Erro ao desfazer armazenamento */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE4837' /* Erro ao desfazer armazenamento */),
          'top-right',
        );
      }
    }
  };

  undoInboundProductStorage = async (inboundOrderId) => {
    try {
      const result = await this.props.undoInboundProductStorage(inboundOrderId);

      if (result.error) {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          result.error,
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE4835' /* Armazenamento desfeito com sucesso */),
          'top-right',
        );
        await this.getInboundOrders();
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            I18n.t('BEE4837' /* Erro ao desfazer armazenamento */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE4837' /* Erro ao desfazer armazenamento */),
          'top-right',
        );
      }
    }
  };

  undoInboundOrderCheck = async (inboundOrderId) => {
    try {
      const resultado = await this.props.undoInboundOrderCheck(inboundOrderId);

      if (resultado.error) {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1062', { 0: resultado.error } /* Houve um erro ao cancelar a conferência. %{0} */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1064' /* Conferência dos produtos cancelada com sucesso */),
          'top-right',
        );
        await this.getInboundOrders();
        // const orderSelect = this.props.inboundOrdersPanel.find(order => order.id === inboundOrderId)
        // await this.setInboundOrderSelect(orderSelect)
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            I18n.t('BEE1062' /* Houve um erro ao cancelar a conferência. %{0} */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1062' /* Houve um erro ao cancelar a conferência. %{0} */),
          'top-right',
        );
      }
    }
  };

  undoInboundOrderProductCheck = async (inboundOrderProductId) => {
    try {
      const orderStatus = this.state.inboundOrderSelect.status;
      if (orderStatus > 6) {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1063' /* O pedido deste produto já teve a armazenagem iniciada */),
          'top-right',
        );
        return;
      }

      const resultado = await this.props.undoInboundOrderProductCheck(inboundOrderProductId);

      if (resultado.error) {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1062', { 0: resultado.error } /* Houve um erro ao cancelar a conferência. %{0} */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1064' /* Conferência dos produtos cancelada com sucesso */),
          'top-right',
        );
        await this.getInboundOrders();
        // const orderSelect = this.props.inboundOrdersPanel.find(order => order.id === inboundOrderId)
        // await this.setInboundOrderSelect(orderSelect)
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            I18n.t('BEE1062' /* Houve um erro ao cancelar a conferência. %{0} */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1062' /* Houve um erro ao cancelar a conferência. %{0} */),
          'top-right',
        );
      }
    }
  };

  assignCheckUser = async (inboundOrderId, userId) => {
    try {
      const result = await this.props.assignCheckUser(inboundOrderId, userId);
      if (result) {
        if (userId) {
          addNotification(
            'success',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            I18n.t('BEE1065' /* Conferente atribuído com sucesso ! */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            I18n.t('BEE2064' /* Usuário desvinculado com sucesso */),
            'top-right',
          );
        }
        await this.getInboundOrders();
        // const orderSelect = this.props.inboundOrdersPanel.find(order => order.id === inboundOrderId)
        // await this.setInboundOrderSelect(orderSelect)
      } else {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1066' /* Houve um erro ao fazer a atribuição */),
          'top-right',
        );
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE440' /* Monitor de Recebimento */),
            I18n.t('BEE1067' /* Houve um erro ao atribuir o conferente %{0} */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE440' /* Monitor de Recebimento */),
          I18n.t('BEE1067' /* Houve um erro ao atribuir o conferente %{0} */),
          'top-right',
        );
      }
    }
  };

  showColumn = (layout, fieldName) => {
    if (layout) return layout[fieldName] !== false;
    return true;
  };

  setValue = (attr, value) => {
    this.setState({ [attr]: value });
  };

  showPageLayoutModal = () => {
    this.setState({ showModalPageLayout: true });
  };

  closePageLayoutModal = () => {
    this.getPageLayout();
    this.setState({ showModalPageLayout: false });
  };

  getPageLayout = async () => {
    const { userLogged } = this.props;
    if (!userLogged?.mainBranchData) return;

    const layoutSelected = await this.props.getPageLayout({
      branchCode: userLogged.mainBranchData.code,
      page: this.props.location.pathname,
    });

    if (layoutSelected?.layout) {
      const l = layoutSelected.layout;
      const pageLayout = {
        showSupplier: l.showSupplier ?? true,
        showOrderType: l.showOrderType ?? true,
        showSerie: l.showSerie ?? true,
        showStatus: l.showStatus ?? true,
        showPrintLabel: l.showPrintLabel ?? true,
        showDeliveryDate: l.showDeliveryDate ?? true,
        showPrintedDate: l.showPrintedDate ?? true,
        showIntegrationDate: l.showIntegrationDate ?? true,
        showVolumes: l.showVolumes ?? true,
        showInspection: l.showInspection ?? true,
        showVehiclePlate: l.showVehiclePlate ?? true,
        showPlateCheck: l.showPlateCheck ?? true,
        showChecked: l.showChecked ?? true,
        showStored: l.showStored ?? true,
        showCanceled: l.showCanceled ?? true,
        showDivergence: l.showDivergence ?? true,
        showUserCheck: l.showUserCheck ?? true,
        showPlateCheckUser: l.showPlateCheckUser ?? true,
        showPlateCheckDate: l.showPlateCheckDate ?? true,
        showStartCheckUser: l.showStartCheckUser ?? true,
        showStartCheckDate: l.showStartCheckDate ?? true,
        showFinishCheckUser: l.showFinishCheckUser ?? true,
        showFinishCheckDate: l.showFinishCheckDate ?? true,
        showStartStorageUser: l.showStartStorageUser ?? true,
        showStartStorageDate: l.showStartStorageDate ?? true,
        showFinishStorageUser: l.showFinishStorageUser ?? true,
        showFinishStorageDate: l.showFinishStorageDate ?? true,
        showCancelUser: l.showCancelUser ?? true,
        showCancelDate: l.showCancelDate ?? true,
        showDivergenceUser: l.showDivergenceUser ?? true,
        showDivergenceDate: l.showDivergenceDate ?? true,
        showProductName: l.showProductName ?? true,
        showProductComplementCode: l.showProductComplementCode ?? true,
        showUnitMeasure: l.showUnitMeasure ?? true,
        showBaptismLabel: l.showBaptismLabel ?? true,
        showQuantity: l.showQuantity ?? true,
        showQuantityCheck: l.showQuantityCheck ?? true,
        showInspected: l.showInspected ?? true,
        showInspectedAt: l.showInspectedAt ?? true,
        showInspectionUser: l.showInspectionUser ?? true,
        showInspectionNotes: l.showInspectionNotes ?? true,
        showPending: l.showPending ?? true,
        showQuantityStorage: l.showQuantityStorage ?? true,
        showQuantityDamage: l.showQuantityDamage ?? true,
        showQuantityDivergence: l.showQuantityDivergence ?? true,
        showProductStatus: l.showProductStatus ?? true,
        showPurchaseOrder: l.showPurchaseOrder ?? true,
        showControlExpirationDate: l.showControlExpirationDate ?? true,
        showStockControlType: l.showStockControlType ?? true,
        showCheckUser: l.showCheckUser ?? true,
        showCheckProductAt: l.showCheckProductAt ?? true,
        showStorageUser: l.showStorageUser ?? true,
        showStorageProductAt: l.showStorageProductAt ?? true,
        showLotProductCode: l.showLotProductCode ?? true,
        showLotProductName: l.showLotProductName ?? true,
        showLotSerialGroupCode: l.showLotSerialGroupCode ?? true,
        showLotStatus: l.showLotStatus ?? true,
        showLotQuantity: l.showLotQuantity ?? true,
        showLotQuantityStorage: l.showLotQuantityStorage ?? true,
        showLotQuantityDamage: l.showLotQuantityDamage ?? true,
        showLotExpDate: l.showLotExpDate ?? true,
        showLotStorageUser: l.showLotStorageUser ?? true,
        showLotStorageProductAt: l.showLotStorageProductAt ?? true,
      };

      this.setState({
        pageLayout,
        showSupplier: pageLayout.showSupplier,
        showOrderType: pageLayout.showOrderType,
        showSerie: pageLayout.showSerie,
        showStatus: pageLayout.showStatus,
        showPrintLabel: pageLayout.showPrintLabel,
        showDeliveryDate: pageLayout.showDeliveryDate,
        showPrintedDate: pageLayout.showPrintedDate,
        showIntegrationDate: pageLayout.showIntegrationDate,
        showVolumes: pageLayout.showVolumes,
        showInspection: pageLayout.showInspection,
        showVehiclePlate: pageLayout.showVehiclePlate,
        showPlateCheck: pageLayout.showPlateCheck,
        showChecked: pageLayout.showChecked,
        showStored: pageLayout.showStored,
        showCanceled: pageLayout.showCanceled,
        showDivergence: pageLayout.showDivergence,
        showUserCheck: pageLayout.showUserCheck,
        showPlateCheckUser: pageLayout.showPlateCheckUser,
        showPlateCheckDate: pageLayout.showPlateCheckDate,
        showStartCheckUser: pageLayout.showStartCheckUser,
        showStartCheckDate: pageLayout.showStartCheckDate,
        showFinishCheckUser: pageLayout.showFinishCheckUser,
        showFinishCheckDate: pageLayout.showFinishCheckDate,
        showStartStorageUser: pageLayout.showStartStorageUser,
        showStartStorageDate: pageLayout.showStartStorageDate,
        showFinishStorageUser: pageLayout.showFinishStorageUser,
        showFinishStorageDate: pageLayout.showFinishStorageDate,
        showCancelUser: pageLayout.showCancelUser,
        showCancelDate: pageLayout.showCancelDate,
        showDivergenceUser: pageLayout.showDivergenceUser,
        showDivergenceDate: pageLayout.showDivergenceDate,
        showProductName: pageLayout.showProductName,
        showProductComplementCode: pageLayout.showProductComplementCode,
        showUnitMeasure: pageLayout.showUnitMeasure,
        showBaptismLabel: pageLayout.showBaptismLabel,
        showQuantity: pageLayout.showQuantity,
        showQuantityCheck: pageLayout.showQuantityCheck,
        showInspected: pageLayout.showInspected,
        showInspectedAt: pageLayout.showInspectedAt,
        showInspectionUser: pageLayout.showInspectionUser,
        showInspectionNotes: pageLayout.showInspectionNotes,
        showPending: pageLayout.showPending,
        showQuantityStorage: pageLayout.showQuantityStorage,
        showQuantityDamage: pageLayout.showQuantityDamage,
        showQuantityDivergence: pageLayout.showQuantityDivergence,
        showProductStatus: pageLayout.showProductStatus,
        showPurchaseOrder: pageLayout.showPurchaseOrder,
        showControlExpirationDate: pageLayout.showControlExpirationDate,
        showStockControlType: pageLayout.showStockControlType,
        showCheckUser: pageLayout.showCheckUser,
        showCheckProductAt: pageLayout.showCheckProductAt,
        showStorageUser: pageLayout.showStorageUser,
        showStorageProductAt: pageLayout.showStorageProductAt,
        showLotProductCode: pageLayout.showLotProductCode,
        showLotProductName: pageLayout.showLotProductName,
        showLotSerialGroupCode: pageLayout.showLotSerialGroupCode,
        showLotStatus: pageLayout.showLotStatus,
        showLotQuantity: pageLayout.showLotQuantity,
        showLotQuantityStorage: pageLayout.showLotQuantityStorage,
        showLotQuantityDamage: pageLayout.showLotQuantityDamage,
        showLotExpDate: pageLayout.showLotExpDate,
        showLotStorageUser: pageLayout.showLotStorageUser,
        showLotStorageProductAt: pageLayout.showLotStorageProductAt,
      });
    }
  };

  updatePageLayoutArray = async () => {
    const {
      showSupplier, showOrderType, showSerie, showStatus, showPrintLabel, showDeliveryDate, showPrintedDate,
      showIntegrationDate, showVolumes, showInspection, showVehiclePlate, showPlateCheck, showChecked, showStored,
      showCanceled, showDivergence, showUserCheck, showPlateCheckUser, showPlateCheckDate, showStartCheckUser,
      showStartCheckDate, showFinishCheckUser, showFinishCheckDate, showStartStorageUser, showStartStorageDate,
      showFinishStorageUser, showFinishStorageDate, showCancelUser, showCancelDate, showDivergenceUser,
      showDivergenceDate, showProductName, showUnitMeasure, showBaptismLabel, showQuantity, showQuantityCheck,
      showInspected, showInspectedAt, showInspectionUser, showInspectionNotes, showPending, showQuantityStorage,
      showQuantityDamage, showQuantityDivergence, showProductStatus, showPurchaseOrder, showControlExpirationDate,
      showStockControlType, showCheckUser, showCheckProductAt, showStorageUser, showStorageProductAt,
      showLotProductCode, showLotProductName, showLotSerialGroupCode,
      showLotStatus, showLotQuantity, showLotQuantityStorage, showLotQuantityDamage, showLotExpDate,
      showLotStorageUser, showLotStorageProductAt, showProductComplementCode,
    } = this.state;

    const layout = {
      showSupplier,
      showOrderType,
      showSerie,
      showStatus,
      showPrintLabel,
      showDeliveryDate,
      showPrintedDate,
      showIntegrationDate,
      showVolumes,
      showInspection,
      showVehiclePlate,
      showPlateCheck,
      showChecked,
      showStored,
      showCanceled,
      showDivergence,
      showUserCheck,
      showPlateCheckUser,
      showPlateCheckDate,
      showStartCheckUser,
      showStartCheckDate,
      showFinishCheckUser,
      showFinishCheckDate,
      showStartStorageUser,
      showStartStorageDate,
      showFinishStorageUser,
      showFinishStorageDate,
      showCancelUser,
      showCancelDate,
      showDivergenceUser,
      showDivergenceDate,
      showProductName,
      showProductComplementCode,
      showUnitMeasure,
      showBaptismLabel,
      showQuantity,
      showQuantityCheck,
      showInspected,
      showInspectedAt,
      showInspectionUser,
      showInspectionNotes,
      showPending,
      showQuantityStorage,
      showQuantityDamage,
      showQuantityDivergence,
      showProductStatus,
      showPurchaseOrder,
      showControlExpirationDate,
      showStockControlType,
      showCheckUser,
      showCheckProductAt,
      showStorageUser,
      showStorageProductAt,
      showLotProductCode,
      showLotProductName,
      showLotSerialGroupCode,
      showLotStatus,
      showLotQuantity,
      showLotQuantityStorage,
      showLotQuantityDamage,
      showLotExpDate,
      showLotStorageUser,
      showLotStorageProductAt,
    };

    try {
      const { userLogged } = this.props;
      if (!userLogged?.mainBranchData) {
        addNotification(
          'danger',
          I18n.t('BEE4440' /* Atualizar Layout da Página */),
          I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
          'top-right',
        );
        return;
      }

      await this.props.updatePageLayout({
        branchCode: userLogged.mainBranchData.code,
        page: this.props.location.pathname,
        layout,
      });

      addNotification(
        'success',
        I18n.t('BEE4440' /* Atualizar Layout da Página */),
        I18n.t('BEE4442' /* Atualização do Layout de Página efetuada com sucesso! */),
        'top-right',
      );

      this.setState({
        pageLayout: layout,
        showModalPageLayout: false,
      });
    } catch (err) {
      if (err.response?.data?.error) {
        const { error } = err.response.data;

        addNotification(
          'danger',
          I18n.t('BEE4440' /* Atualizar Layout da Página */),
          error.details || error.message
            ? `${error.code} - ${error.details || error.message}`
            : I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4440' /* Atualizar Layout da Página */),
          I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
          'top-right',
        );
      }
    }
  };

  resetLayout = () => {
    this.setState({
      showSupplier: true,
      showOrderType: true,
      showSerie: true,
      showStatus: true,
      showPrintLabel: true,
      showDeliveryDate: true,
      showPrintedDate: true,
      showIntegrationDate: true,
      showVolumes: true,
      showInspection: true,
      showVehiclePlate: true,
      showPlateCheck: true,
      showChecked: true,
      showStored: true,
      showCanceled: true,
      showDivergence: true,
      showUserCheck: true,
      showPlateCheckUser: true,
      showPlateCheckDate: true,
      showStartCheckUser: true,
      showStartCheckDate: true,
      showFinishCheckUser: true,
      showFinishCheckDate: true,
      showStartStorageUser: true,
      showStartStorageDate: true,
      showFinishStorageUser: true,
      showFinishStorageDate: true,
      showCancelUser: true,
      showCancelDate: true,
      showDivergenceUser: true,
      showDivergenceDate: true,
      showProductName: true,
      showProductComplementCode: true,
      showUnitMeasure: true,
      showBaptismLabel: true,
      showQuantity: true,
      showQuantityCheck: true,
      showInspected: true,
      showInspectedAt: true,
      showInspectionUser: true,
      showInspectionNotes: true,
      showPending: true,
      showQuantityStorage: true,
      showQuantityDamage: true,
      showQuantityDivergence: true,
      showProductStatus: true,
      showPurchaseOrder: true,
      showControlExpirationDate: true,
      showStockControlType: true,
      showCheckUser: true,
      showCheckProductAt: true,
      showStorageUser: true,
      showStorageProductAt: true,
      showLotProductCode: true,
      showLotProductName: true,
      showLotSerialGroupCode: true,
      showLotStatus: true,
      showLotQuantity: true,
      showLotQuantityStorage: true,
      showLotQuantityDamage: true,
      showLotExpDate: true,
      showLotStorageUser: true,
      showLotStorageProductAt: true,
    });
  };

  createPageLayoutModal = () => {
    const {
      showModalPageLayout,
      showSupplier, showOrderType, showSerie, showStatus, showPrintLabel, showDeliveryDate, showPrintedDate,
      showIntegrationDate, showVolumes, showInspection, showVehiclePlate, showPlateCheck, showChecked, showStored,
      showCanceled, showDivergence, showUserCheck, showPlateCheckUser, showPlateCheckDate, showStartCheckUser,
      showStartCheckDate, showFinishCheckUser, showFinishCheckDate, showStartStorageUser, showStartStorageDate,
      showFinishStorageUser, showFinishStorageDate, showCancelUser, showCancelDate, showDivergenceUser,
      showDivergenceDate, showProductName, showUnitMeasure, showBaptismLabel, showQuantity, showQuantityCheck,
      showInspected, showInspectedAt, showInspectionUser, showInspectionNotes, showPending, showQuantityStorage,
      showQuantityDamage, showQuantityDivergence, showProductStatus, showPurchaseOrder, showControlExpirationDate,
      showStockControlType, showCheckUser, showCheckProductAt, showStorageUser, showStorageProductAt,
      showLotProductCode, showLotProductName, showLotSerialGroupCode,
      showLotStatus, showLotQuantity, showLotQuantityStorage, showLotQuantityDamage, showLotExpDate,
      showLotStorageUser, showLotStorageProductAt, showProductComplementCode,
    } = this.state;

    return (
      <Modal size="md" isOpen={showModalPageLayout} toggle={this.closePageLayoutModal}>
        <ModalHeader toggle={this.closePageLayoutModal}>
          <span className="text-center">
            {I18n.t('BEE4439' /* Gerenciar Colunas */).toLocaleUpperCase()}
          </span>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12 text-right">
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE1378' /* Documento */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showSupplier,
                    'showSupplier',
                    I18n.t('BEE342' /* Fornecedor */),
                  ),
                  formContext.createToggleBox(
                    showOrderType,
                    'showOrderType',
                    I18n.t('BEE200' /* Tipo */),
                  ),
                  formContext.createToggleBox(
                    showSerie,
                    'showSerie',
                    I18n.t('BEE403' /* Série */),
                  ),
                  formContext.createToggleBox(
                    showStatus,
                    'showStatus',
                    I18n.t('BEE224' /* Status */),
                  ),
                  formContext.createToggleBox(
                    showPrintLabel,
                    'showPrintLabel',
                    I18n.t('BEE1477' /* Impressão Etiqueta */),
                  ),
                  formContext.createToggleBox(
                    showDeliveryDate,
                    'showDeliveryDate',
                    I18n.t('BEE444' /* Data de Entrega */),
                  ),
                  formContext.createToggleBox(
                    showPrintedDate,
                    'showPrintedDate',
                    I18n.t('BEE1970' /* Data de Impressão */),
                  ),
                  formContext.createToggleBox(
                    showIntegrationDate,
                    'showIntegrationDate',
                    I18n.t('BEE2224' /* Data Integração */),
                  ),
                  formContext.createToggleBox(
                    showVolumes,
                    'showVolumes',
                    I18n.t('BEE405' /* Volumes */),
                  ),
                  formContext.createToggleBox(
                    showInspection,
                    'showInspection',
                    I18n.t('BEE4170' /* Pend. Inspeção */),
                  ),
                  formContext.createToggleBox(
                    showVehiclePlate,
                    'showVehiclePlate',
                    I18n.t('BEE400' /* Placa do Veículo */),
                  ),
                  formContext.createToggleBox(
                    showPlateCheck,
                    'showPlateCheck',
                    I18n.t('BEE399' /* Conferência de Placa */),
                  ),
                  formContext.createToggleBox(
                    showChecked,
                    'showChecked',
                    I18n.t('BEE445' /* Conferido */),
                  ),
                  formContext.createToggleBox(
                    showStored,
                    'showStored',
                    I18n.t('BEE427' /* Armazenado */),
                  ),
                  formContext.createToggleBox(
                    showCanceled,
                    'showCanceled',
                    I18n.t('BEE64' /* Cancelado */),
                  ),
                  formContext.createToggleBox(
                    showDivergence,
                    'showDivergence',
                    I18n.t('BEE176' /* Divergência */),
                  ),
                  formContext.createToggleBox(
                    showUserCheck,
                    'showUserCheck',
                    I18n.t('BEE805' /* Conferente */),
                  ),
                  formContext.createToggleBox(
                    showPlateCheckUser,
                    'showPlateCheckUser',
                    I18n.t('BEE446' /* Usuário Conferência Placa */),
                  ),
                  formContext.createToggleBox(
                    showPlateCheckDate,
                    'showPlateCheckDate',
                    I18n.t('BEE447' /* Data Conferência Placa */),
                  ),
                  formContext.createToggleBox(
                    showStartCheckUser,
                    'showStartCheckUser',
                    I18n.t('BEE448' /* Usuário Início Conferência */),
                  ),
                  formContext.createToggleBox(
                    showStartCheckDate,
                    'showStartCheckDate',
                    I18n.t('BEE449' /* Data Início Conferência */),
                  ),
                  formContext.createToggleBox(
                    showFinishCheckUser,
                    'showFinishCheckUser',
                    I18n.t('BEE450' /* Usuário Fim Conferência */),
                  ),
                  formContext.createToggleBox(
                    showFinishCheckDate,
                    'showFinishCheckDate',
                    I18n.t('BEE451' /* Data Fim Conferência */),
                  ),
                  formContext.createToggleBox(
                    showStartStorageUser,
                    'showStartStorageUser',
                    I18n.t('BEE452' /* Usuário Início Armazenagem */),
                  ),
                  formContext.createToggleBox(
                    showStartStorageDate,
                    'showStartStorageDate',
                    I18n.t('BEE453' /* Data Início Armazenagem */),
                  ),
                  formContext.createToggleBox(
                    showFinishStorageUser,
                    'showFinishStorageUser',
                    I18n.t('BEE454' /* Usuário Fim Armazenagem */),
                  ),
                  formContext.createToggleBox(
                    showFinishStorageDate,
                    'showFinishStorageDate',
                    I18n.t('BEE455' /* Data Fim Armazenagem */),
                  ),
                  formContext.createToggleBox(
                    showCancelUser,
                    'showCancelUser',
                    I18n.t('BEE458' /* Usuário Cancela */),
                  ),
                  formContext.createToggleBox(
                    showCancelDate,
                    'showCancelDate',
                    I18n.t('BEE459' /* Data Cancelada */),
                  ),
                  formContext.createToggleBox(
                    showDivergenceUser,
                    'showDivergenceUser',
                    I18n.t('BEE460' /* Usuário Divergência */),
                  ),
                  formContext.createToggleBox(
                    showDivergenceDate,
                    'showDivergenceDate',
                    I18n.t('BEE461' /* Data Divergência */),
                  ),
                ])}
              />
            </div>
          </div>
          <hr />
          <div className="col-md-12 text-right">
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE27' /* Produtos */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showProductComplementCode,
                    'showProductComplementCode',
                    I18n.t('BEE695' /* Código Complementar */),
                  ),
                  formContext.createToggleBox(
                    showProductName,
                    'showProductName',
                    I18n.t('BEE277' /* Descrição */),
                  ),
                  formContext.createToggleBox(
                    showUnitMeasure,
                    'showUnitMeasure',
                    I18n.t('BEE384' /* Unidade */),
                  ),
                  formContext.createToggleBox(
                    showBaptismLabel,
                    'showBaptismLabel',
                    I18n.t('BEE425' /* Batismo */),
                  ),
                  formContext.createToggleBox(
                    showQuantity,
                    'showQuantity',
                    I18n.t('BEE441' /* Quantidade */),
                  ),
                  formContext.createToggleBox(
                    showQuantityCheck,
                    'showQuantityCheck',
                    I18n.t('BEE464' /* Conferida */),
                  ),
                  formContext.createToggleBox(
                    showInspected,
                    'showInspected',
                    I18n.t('BEE4148' /* Status Inspeção */),
                  ),
                  formContext.createToggleBox(
                    showInspectedAt,
                    'showInspectedAt',
                    I18n.t('BEE4171' /* Data/Hora Inspeção */),
                  ),
                  formContext.createToggleBox(
                    showInspectionUser,
                    'showInspectionUser',
                    I18n.t('BEE4172' /* Usuário Inspeção */),
                  ),
                  formContext.createToggleBox(
                    showInspectionNotes,
                    'showInspectionNotes',
                    I18n.t('BEE4173' /* Obs. Inspeção */),
                  ),
                  formContext.createToggleBox(
                    showPending,
                    'showPending',
                    I18n.t('BEE3701' /* Pend. Armazenar */),
                  ),
                  formContext.createToggleBox(
                    showQuantityStorage,
                    'showQuantityStorage',
                    I18n.t('BEE3196' /* Armazenada */),
                  ),
                  formContext.createToggleBox(
                    showQuantityDamage,
                    'showQuantityDamage',
                    I18n.t('BEE3702' /* Avariada */),
                  ),
                  formContext.createToggleBox(
                    showQuantityDivergence,
                    'showQuantityDivergence',
                    I18n.t('BEE176' /* Divergência */),
                  ),
                  formContext.createToggleBox(
                    showProductStatus,
                    'showProductStatus',
                    I18n.t('BEE224' /* Status */),
                  ),
                  formContext.createToggleBox(
                    showPurchaseOrder,
                    'showPurchaseOrder',
                    I18n.t('BEE3789' /* Ordem de Compra */),
                  ),
                  formContext.createToggleBox(
                    showControlExpirationDate,
                    'showControlExpirationDate',
                    I18n.t('BEE701' /* Controlar Vencimento */),
                  ),
                  formContext.createToggleBox(
                    showStockControlType,
                    'showStockControlType',
                    I18n.t('BEE708' /* Tipo de Controle de Estoque */),
                  ),
                  formContext.createToggleBox(
                    showCheckUser,
                    'showCheckUser',
                    I18n.t('BEE466' /* Usuário Conferência */),
                  ),
                  formContext.createToggleBox(
                    showCheckProductAt,
                    'showCheckProductAt',
                    I18n.t('BEE467' /* Data Conferência */),
                  ),
                  formContext.createToggleBox(
                    showStorageUser,
                    'showStorageUser',
                    I18n.t('BEE468' /* Usuário Armazenagem */),
                  ),
                  formContext.createToggleBox(
                    showStorageProductAt,
                    'showStorageProductAt',
                    I18n.t('BEE469' /* Data Armazenagem */),
                  ),
                ])}
              />
            </div>
          </div>
          <hr />
          <div className="col-md-12 text-right">
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE442' /* Lotes */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showLotProductCode,
                    'showLotProductCode',
                    I18n.t('BEE225' /* Produto */),
                  ),
                  formContext.createToggleBox(
                    showLotProductName,
                    'showLotProductName',
                    I18n.t('BEE277' /* Descrição */),
                  ),
                  formContext.createToggleBox(
                    showLotSerialGroupCode,
                    'showLotSerialGroupCode',
                    I18n.t('BEE2978' /* Agrupadora */),
                  ),
                  formContext.createToggleBox(
                    showLotStatus,
                    'showLotStatus',
                    I18n.t('BEE224' /* Status */),
                  ),
                  formContext.createToggleBox(
                    showLotQuantity,
                    'showLotQuantity',
                    I18n.t('BEE441' /* Quantidade */),
                  ),
                  formContext.createToggleBox(
                    showLotQuantityStorage,
                    'showLotQuantityStorage',
                    I18n.t('BEE3196' /* Armazenada */),
                  ),
                  formContext.createToggleBox(
                    showLotQuantityDamage,
                    'showLotQuantityDamage',
                    I18n.t('BEE465' /* Danificada */),
                  ),
                  formContext.createToggleBox(
                    showLotExpDate,
                    'showLotExpDate',
                    I18n.t('BEE434' /* Data de Validade */),
                  ),
                  formContext.createToggleBox(
                    showLotStorageUser,
                    'showLotStorageUser',
                    I18n.t('BEE468' /* Usuário Armazenagem */),
                  ),
                  formContext.createToggleBox(
                    showLotStorageProductAt,
                    'showLotStorageProductAt',
                    I18n.t('BEE469' /* Data Armazenagem */),
                  ),
                ])}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <button
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={this.resetLayout}
            >
              {I18n.t('BEE4443' /* Restaurar padrão */)}
            </button>
            <div>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-white p-5 m-5"
                onClick={this.closePageLayoutModal}
              >
                {I18n.t('BEE99' /* Cancelar */)}
              </OneClickButton>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={this.updatePageLayoutArray}
              >
                {I18n.t('BEE139' /* Atualizar */)}
              </OneClickButton>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  };

  render() {
    const { inboundOrdersPanel = [] } = this.props;

    const {
      startDate, endDate, currentRange, inboundOrdersProductsPanel = [],
      inboundOrderSelect, productSelect, productLotsPanel = [],
    } = this.state;

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1400' /* Movimentação */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE36' /* Recebimento */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE440' /* Monitor de Recebimento */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {I18n.t('BEE440' /* Monitor de Recebimento */)}
          </h1>
          <WikiHelp wikiPath={ROUTES.INBOUND_ORDER_MONITOR_HELP} />
        </div>
        <OrderTable
          getUserPrinterOptions={() => this.props.getUserPrinterOptions()}
          updateNote={(inboundOrderId, note) => this.props.updateOrderNote(inboundOrderId, note)}
          printLabel={(
            preConferenceLabelId,
            printerCode,
          ) => this.props.printPreConferenceLabel(preConferenceLabelId, printerCode)}
          getInboundOrders={this.getInboundOrders}
          setInboundOrderSelect={this.setInboundOrderSelect}
          inboundOrdersPanel={inboundOrdersPanel}
          handleDateApplyEvent={this.handleDateApplyEvent}
          startDate={startDate}
          endDate={endDate}
          currentRange={currentRange}
          inboundOrderSelect={inboundOrderSelect}
          undoInboundOrderCheck={this.undoInboundOrderCheck}
          undoInboundStorage={this.undoInboundStorage}
          validateUndoInboundStorage={this.props.validateUndoInboundStorage}
          assignCheckUser={this.assignCheckUser}
          getBranchUsers={this.props.getBranchUsers}
          cancelOrder={this.cancelOrder}
          getListInboundOrderProducts={this.props.getListInboundOrderProducts}
          pageLayout={this.state.pageLayout}
          showColumn={this.showColumn}
          showPageLayoutModal={this.showPageLayoutModal}
        />
        <ProductTable
          getInboundOrders={this.getInboundOrders}
          updateNote={(inboundOrderProductId, note) => this.props.updateNote(inboundOrderProductId, note)}
          updateProductInspection={(inboundOrderProductId, status, inspectionNotes) => this.props.updateProductInspection(inboundOrderProductId, status, inspectionNotes)}
          inboundOrdersProductsPanel={inboundOrdersProductsPanel}
          productSelect={productSelect}
          setInboundOrderProductSelect={this.setInboundOrderProductSelect}
          undoInboundOrderProductCheck={this.undoInboundOrderProductCheck}
          undoInboundProductStorage={this.undoInboundProductStorage}
          validateUndoInboundProductStorage={this.props.validateUndoInboundProductStorage}
          syncStorage={this.props.syncStorage}
          getListInboundOrderProductPartial={this.getListInboundOrderProductPartial}
          pageLayout={this.state.pageLayout}
          showColumn={this.showColumn}
          showPageLayoutModal={this.showPageLayoutModal}
        />
        <LotTable
          productLotsPanel={productLotsPanel}
          productSelect={productSelect}
          pageLayout={this.state.pageLayout}
          showColumn={this.showColumn}
        />
        {this.createPageLayoutModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  inboundOrdersPanel: state.inboundOrders && state.inboundOrders.inboundOrdersList,
  userLogged: state.app.userLogged && state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  getListInboundOrdersOnly: (startDate, endDate) => dispatch(getListInboundOrdersOnly(startDate, endDate)),
  undoInboundOrderCheck: (inboundOrderId) => dispatch(undoInboundOrderCheck(inboundOrderId)),
  undoInboundOrderProductCheck: (inboundOrderProductId) => dispatch(
    undoInboundOrderProductCheck(inboundOrderProductId),
  ),
  undoInboundStorage: (inboundOrderId) => dispatch(undoInboundStorage(inboundOrderId)),
  undoInboundProductStorage: (inboundOrderProductId) => dispatch(undoInboundProductStorage(inboundOrderProductId)),
  validateUndoInboundStorage: (inboundOrderId) => dispatch(validateUndoInboundStorage(inboundOrderId)),
  validateUndoInboundProductStorage: (inboundOrderProductId) => dispatch(validateUndoInboundProductStorage(inboundOrderProductId)),
  getBranchUsers: (branchCode, orderType) => dispatch(getBranchUsers(branchCode, orderType)),
  assignCheckUser: (inboundOrderId, userId) => dispatch(assignCheckUser(inboundOrderId, userId)),
  updateNote: (inboundOrderProductId, note) => dispatch(updateNote(inboundOrderProductId, note)),
  updateProductInspection: (inboundOrderProductId, status, inspectionNotes) => dispatch(updateProductInspection(inboundOrderProductId, status, inspectionNotes)),
  updateOrderNote: (inboundOrderId, note) => dispatch(updateOrderNote(inboundOrderId, note)),
  syncStorage: (inboundOrderProductId) => dispatch(syncStorage(inboundOrderProductId)),
  getUserPrinterOptions: () => dispatch(getUserPrinterOptions()),
  printPreConferenceLabel: (preConferenceLabelId, printerCode) => dispatch(
    printPreConferenceLabel(preConferenceLabelId, printerCode),
  ),
  cancelOrder: (inboundOrderId, cancelNote) => dispatch(cancelOrder(inboundOrderId, cancelNote)),
  getListInboundOrderProducts: (inboundOrderId) => dispatch(getListInboundOrderProducts(inboundOrderId)),
  getListInboundOrderProductLots: (inboundOrderProductId) => dispatch(
    getListInboundOrderProductLots(inboundOrderProductId),
  ),
  getListInboundOrderProductPartial: (inboundOrderProductId) => dispatch(
    getListInboundOrderProductPartial(inboundOrderProductId),
  ),
  getPageLayout: (pageLayout) => dispatch(getPageLayout(pageLayout)),
  updatePageLayout: (pageLayout) => dispatch(updatePageLayout(pageLayout)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InboundOrdersPanel));
